module.exports = __webpack_public_path__ + "img/about-illustration.0fcf4d1f.png";